import { z } from 'zod';

export const BUGCROWD_WEBHOOK_EVENT_KEYS = [
  'submission.created',
  'submission.updated',
] as const;

export const BugcrowdWebhookEventKeySchema = z.string().min(1);

const BugcrowdWebhookRelationshipDataSchema = z.looseObject({
  id: z.string().min(1),
  type: z.string().nullish(),
});

const BugcrowdWebhookRelationshipRefSchema = z.looseObject({
  data: BugcrowdWebhookRelationshipDataSchema.nullish(),
});

const BugcrowdWebhookEventSchema = z.looseObject({
  id: z.string().min(1).nullish(),
  type: z.string().nullish(),
  attributes: z
    .looseObject({
      key: BugcrowdWebhookEventKeySchema.nullish(),
      created_at: z.string().nullish(),
    })
    .optional(),
  relationships: z
    .looseObject({
      actor: BugcrowdWebhookRelationshipRefSchema.optional(),
      resource: BugcrowdWebhookRelationshipRefSchema.optional(),
    })
    .optional(),
});

const BugcrowdWebhookIncludedResourceSchema = z.looseObject({
  id: z.string().min(1).nullish(),
  type: z.string().nullish(),
  attributes: z.record(z.string(), z.unknown()).optional(),
  relationships: z.record(z.string(), z.unknown()).optional(),
});

export const BugcrowdWebhookPayloadSchema = z.looseObject({
  data: BugcrowdWebhookEventSchema,
  included: z.array(BugcrowdWebhookIncludedResourceSchema).optional(),
});

export type BugcrowdWebhookPayload = z.infer<
  typeof BugcrowdWebhookPayloadSchema
>;

export const extractBugcrowdWebhookEventKey = ({
  payload,
}: {
  payload: BugcrowdWebhookPayload;
}): string | null => payload.data.attributes?.key ?? null;

export const extractBugcrowdWebhookSubmissionId = ({
  payload,
}: {
  payload: BugcrowdWebhookPayload;
}): string | null => {
  const resource = payload.data.relationships?.resource?.data;
  if (!resource?.id) {
    return null;
  }
  if (resource.type && resource.type !== 'submission') {
    return null;
  }
  return resource.id;
};
